import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getMyNotificationsFetchSuccess,
    getMyNotificationsFetchFailure,
    updateMyNotificationsFetchSuccess,
    updateMyNotificationsFetchFailure,
} from './reducer';
import { UserNotificationsDetailResType } from 'src/types/userNotificationsDetail';
import { UserNotificationsType } from 'src/types/user';
import translate from '@translate';

const getMyNotificationsFetchRequest = async () => {
    const res = await api('get', 'api/secure/users/notification/me');
    return res.data;
};

function* getMyNotificationsFetch() {
    try {
        const response: UserNotificationsDetailResType = yield call((): Promise<UserNotificationsDetailResType> =>
            getMyNotificationsFetchRequest()
        );
        yield put(getMyNotificationsFetchSuccess(response));
    } catch (error) {
        yield put(getMyNotificationsFetchFailure());
    }
}

export function* getMyNotificationsFetchWatch() {
    yield takeEvery('myNotifications/getMyNotificationsFetch', getMyNotificationsFetch);
}

const updateMyNotificationsFetchRequest = async (data: UserNotificationsType) => {
    const res = await api('put', 'api/secure/users/notification/me', data);
    return res.data;
};

function* updateMyNotificationsFetch(action: { type: string; payload: UserNotificationsType }) {
    try {
        const response: UserNotificationsDetailResType = yield call((): Promise<UserNotificationsDetailResType> =>
            updateMyNotificationsFetchRequest(action.payload)
        );
        yield put(
            updateMyNotificationsFetchSuccess({
                ...response,
                messageSuccess: { title: translate('users.message.userNotificationsUpdate') },
            })
        );
    } catch (error) {
        yield put(updateMyNotificationsFetchFailure());
    }
}

export function* updateMyNotificationsFetchWatch() {
    yield takeEvery('myNotifications/updateMyNotificationsFetch', updateMyNotificationsFetch);
}
